<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="info.asin + '价格趋势'"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <div class="dayBox">
            <div class="leftDay">
                <el-radio-group @change="changeDay" v-model="query.radioDay" size="mini">
                    <el-radio-button label="30"></el-radio-button>
                    <el-radio-button label="90"></el-radio-button>
                    <el-radio-button label="365"></el-radio-button>
                </el-radio-group>
            </div>
            <div class="rightDay">
                <div>查看过去
                    <el-input type="number" style="width: 100px" v-model="query.day"
                              @change="inputDayChange" size="mini"></el-input>
                    天记录
                </div>
            </div>
        </div>

        <div class="tabSwitch">
            <el-radio-group @change="viewCharts" v-model="query.type" size="mini">
                <el-radio-button label="0">当前价格</el-radio-button>
                <el-radio-button label="1">标签价格</el-radio-button>
                <el-radio-button label="2">折扣率</el-radio-button>
                <el-radio-button label="3">coupon</el-radio-button>
            </el-radio-group>
        </div>

        <div id="chartDom" style="min-width:400px;height:400px"></div>
    </el-dialog>
</template>
<script>
import * as api from '@/api/Product/Product'
import * as echarts from 'echarts'
import {track_asin_sub_get_price_trend} from '@/api/Product/Product'

export default {
    data() {
        return {
            loading: false,
            asinInfo: {},
            query: {
                day: 30,
                radioDay: 30,
                type: '0',
            },
            list: [],
            myChart: null,
            timer: null,
            isshow: false
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: {}
        }
    },
    watch: {
        info: {
            handler(val) {
                this.asinInfo = val
            },
            deep: true,
        },
        visible: {
            handler(val) {
                val && this.asinChangeTrend()
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        asinChangeTrend() {
            this.loading = true
            api.track_asin_sub_get_price_trend({
                id: this.info.id,
                day: this.query.day
            }).then(res => {
                if (res.code === 0) {
                    this.$nextTick(() => {
                        this.list = res.data || []
                        this.viewCharts()
                    })
                }
            }).catch(res => {
                this.$message({
                    type: 'error',
                    message: res.message
                })
            }).finally(() => {
                this.loading = false
            })
        },
        inputDayChange() {
            this.debounce(() => this.asinChangeTrend(), 500)
        },
        debounce(fn, delay) {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => {
                fn.apply(this, arguments)
            }, delay ? delay : 500)
        },
        changeDay(val) {
            this.query.day = val
            this.debounce(() => this.asinChangeTrend(), 500)
        },
        // 关闭弹窗
        handleClose() {
            this.query = {
                day: 30,
                radioDay: 30,
                type: '0',
            }
            this.$emit('close-callback', false)
        },
        viewCharts() {
            let serviceArr = []
            const data = this.list
            let tempKey = ''
            if (data.length > 0) {
                let tempName = ''
                switch (this.query.type) {
                    case '0':
                        tempKey = 'local_price'
                        tempName = '当前价格'
                        break
                    case '1':
                        tempKey = 'list_price'
                        tempName = '标签价格'
                        break
                    case '2':
                        tempKey = 'discount_rate'
                        tempName = '折扣率'
                        break
                    case '3':
                        tempKey = 'coupon_rate'
                        tempName = 'coupon'
                        break
                }

                let obj = {
                    name: tempName,
                    data: [],
                    type: 'line',
                }
                for (const dataItem of data) {
                    let dataItemData = dataItem[tempKey]
                    if (['list_price'].includes(tempKey)) {
                        dataItemData = (dataItem[tempKey] == '' || dataItem[tempKey] == null) ? '' : dataItem[tempKey]
                    } else if (['discount_rate', 'coupon_rate'].includes(tempKey)) {
                        dataItemData = (dataItem[tempKey] == '' || dataItem[tempKey] == null) ? 0 : dataItem[tempKey].replaceAll('%', '')
                    }
                    obj.data.push([dataItem.date, dataItemData])
                }
                serviceArr.push(obj)
                if (tempKey == 'local_price') {
                    let obj = {
                        symbolSize: 15,
                        data: [],
                        type: 'scatter',
                        name: '最低价',
                        itemStyle: {
                            color: 'red',
                        }
                    }
                    for (const dataItem of data) {
                        if (dataItem.is_lowest_price == 1) {
                            obj.data.push([dataItem.date, dataItem[tempKey]])
                        }
                    }
                    serviceArr.push(obj)

                }
            }
            this.myChart = null
            this.myChart = echarts.init(document.getElementById('chartDom'))
            this.option = {
                xAxis: [
                    {
                        axisLine: {
                            lineStyle: {
                                color: '#000'
                            }
                        },
                        splitLine: {
                            show: true
                        },
                        type: 'time',
                        splitNumber: 16,
                        axisLabel: {
                            rotate: 45,
                            interval: 'auto',
                            showMaxLabel: true,
                            formatter: (params, index) =>//自动处理x轴的时间格式，兼容日均和小时2种格式，日均：几月几日，小时：几时
                            {
                                let date = new Date(params)
                                let str
                                if (date.getHours() == 0 || date.getMinutes() > 0 || date.getSeconds() > 0) {
                                    str = index === 0 ? '' : `${date.getMonth() + 1}月${date.getDate()}日`
                                }
                                return str
                            }
                        }
                    }
                ],
                tooltip: {
                    trigger: 'axis',
                    confine: true,
                    formatter: (params) => {
                        let time = ''
                        let timeStr = ''
                        let valueStr = ''
                        time = new Date(params[0].value[0])
                        timeStr = `${time.getMonth() + 1}月${time.getDate()}日`
                        params.map((item) => {
                            if (item.value) {
                                valueStr += `<div style="width:100%}">${item.marker} ${item.seriesName}: ${item.value[1] === '' ? '' : item.value[1] + (['discount_rate', 'coupon_rate'].includes(tempKey) ? '%' : '')}
                                </div>`
                            }
                        })
                        return `${timeStr}<br/><div style="display:flex;justify-content: flex-start;flex-wrap: wrap;width:200px">${valueStr}</div>`
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        minInterval: 1,
                        name: ``,
                        showMaxLabel: true,
                        axisLine: {
                            lineStyle: {
                                color: '#000'
                            }
                        },
                        axisTick: {
                            show: true
                        },
                        axisLabel: {
                            formatter: '{value}',
                            textStyle: {
                                fontSize: 14
                            }
                        }
                    }
                ],
                series: serviceArr
            }

            if (['discount_rate', 'coupon_rate'].includes(tempKey)) {
                this.option.yAxis[0].name = '(%)'
            } else {
                delete this.option.yAxis[0].name
            }

            // 绘制图表
            this.myChart.setOption(this.option, true)
        }

    }
}
</script>
<style type="text/scss" lang="scss">
.dayBox {
    display: flex;
    justify-content: space-between;
}

.tabSwitch {
    margin-top: 15px;
}
</style>

